'use strict';

var superagent = require('superagent');
var cookie = require('react-cookie');
var Helpers = require('./helpers');
var config = require('../../config');

var GetAgentData = {
  agentFromReferrer: function agentFromReferrer() {
    var agents = this.props.agents;

    var referrer = typeof window !== 'undefined' ? window.document.referrer : '';
    var seoSearch = new RegExp(/^[a-z]*:\/\/[^/]*(\.google\.|\.yahoo\.|\.bing\.|\.ask\.|\.aol\.|\.wow\.|\.webcrawler\.|\.mywebsearch\.|\.infospace\.|\.info\.|\.dogpile\.|\.duckduckgo\.|\.blekko\.)[^/]*/i);
    if (referrer && seoSearch.test(referrer) && !Helpers.getParameterByName('adcode', true) && !Helpers.getParameterByName('email', true)) {
      var searchAgent = agents.search ? agents.search : this.getDefaultAgent();
      return searchAgent;
      // If SEO referer and not got url params of email or adcode then set to searchagent code
    }
  },
  agentFromUrl: function agentFromUrl() {
    var urlAgent = Helpers.getParameterByName('agent', true);
    var agentTest = new RegExp(/^[0-9a-z]{4,5}$/i);
    if (urlAgent && agentTest.test(urlAgent)) {
      return urlAgent;
    }
  },
  agentFromCookie: function agentFromCookie() {
    if (cookie.load('agent')) {
      return cookie.load('agent');
    }
  },
  getDefaultAgent: function getDefaultAgent() {
    var agents = this.props.agents;

    return agents.main ? agents.main : 'WT894';
  },
  getAgent: function getAgent() {
    var agent = this.agentFromReferrer() || this.agentFromUrl() || this.agentFromCookie() || this.getDefaultAgent();
    this.setAgentCookie(agent);
    return agent;
  },
  setAgentCookie: function setAgentCookie(agent) {
    cookie.remove('agent', '/');
    var settings = this.props.settings;

    var expiry = new Date();
    expiry.setTime(expiry.getTime() + 90 * 24 * 60 * 60 * 1000);
    var opts = { expires: expiry, path: '/' };
    if (settings.cookieDomain) opts.domain = settings.cookieDomain;
    cookie.save('agent', agent, opts);
  },
  agentData: function agentData(obj, initial) {
    var _props = this.props,
        agents = _props.agents,
        settings = _props.settings;

    var data = {};
    if (initial) {
      try {
        data = require('../' + settings.pluginsExportDir + '/' + agents.main + '.json');
        data.agent = data.code;
      } catch (e) {
        data = {};
      }
    }
    if (!data.agent) {
      data = {
        agent: this.getAgent(),
        typeRID: 'D',
        groupCode: 'X0'
      };
      if (obj) return data.hasOwnProperty(obj) ? data[obj] : false;
    }
    return data;
  },
  checkAgent: function checkAgent(agent, cb) {
    if (this.agentData('DDI') && this.agentData('DDI') !== '') return cb(this.agentData());
    var defaultLocation = config.domainSettings.language ? config.domainSettings.language.toUpperCase() : 'UK';
    superagent('//hapi.holidayextras.co.uk/legacy/agent_lookup/' + agent + '.js?key=foo&country=' + defaultLocation, function (err, res) {
      if (err) return;
      if (err || !res.text) return;
      var record = {};
      try {
        record = JSON.parse(res.text);
      } catch (error) {
        console.log(error);
        return;
      }
      if (!(record.API_Reply.RecordSet && record.API_Reply.RecordSet.Record)) return;
      record.API_Reply.RecordSet.Record.map(function (item) {
        var name = item.name,
            code = item.code,
            groupCode = item.groupCode,
            typeRID = item.typeRID,
            DDI = item.DDI,
            promocode = item.promocode,
            cashback = item.cashback,
            data = item.data;

        if (isNaN(agent) && agent.toUpperCase() !== code.toUpperCase()) return;
        var result = {
          name: name,
          agent: agent,
          typeRID: typeRID,
          groupCode: groupCode,
          DDI: DDI,
          promocode: promocode,
          cashback: cashback,
          OptionFlags: data.OptionFlags
        };

        cb(result);
      });
    });
  },
  assignAgentsIdentifiedByUrl: function assignAgentsIdentifiedByUrl() {
    var agents = this.props.agents;

    var agentIDs = {};
    if (agents && agents.allowedUrlAgentIDs) {
      agents.allowedUrlAgentIDs.forEach(function (urlAgent) {
        agentIDs[urlAgent] = Helpers.getParameterByName(urlAgent, false);
      });
      return agentIDs;
    }
  },
  componentDidMount: function componentDidMount() {
    var agentData = this.state.agentData;

    if (agentData.agent !== this.getDefaultAgent()) this.checkAgent(agentData.agent, this.updateAgentData);
  },
  getInitialState: function getInitialState() {
    return {
      agentData: this.agentData(false, true)
    };
  },
  updateAgentData: function updateAgentData(data) {
    var result = this.assignAgentsIdentifiedByUrl();
    if (result) data.agentsByUrl = result;
    data.agent = data.agent.toUpperCase();
    this.setState({
      agentData: data
    });
  }
};

module.exports = GetAgentData;


// WEBPACK FOOTER //
// ./_plugins/lib/agents.js